export const NameCard = ({ deptIcon, deptName, className, isBottom }) => {
  return (
    <div
      style={{ display: "flex", flexDirection: "column", minWidth: "192px" }}
    >
      <div
        className={`namecard-container ${className}`}
        style={{ flexDirection: "column", height: "209px" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            cursor: "pointer",
            gap: "33px",
          }}
        >
          <h5>{deptName}</h5>
          {deptIcon && (
            <img src={deptIcon} alt="Add icon" width={50} height={50} />
          )}
        </div>
      </div>
      {isBottom && (
        <div className="ambition-component-bottom">
          <input
            //   value={productNum}
            //   onChange={(e) => setProductNum(e.target.value)}
            placeholder="Responsible: type name"
          />
        </div>
      )}
    </div>
  );
};
